import { Component, Input, OnInit,Output, EventEmitter } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { BaseDynamicForm } from 'src/app/core/services/base-dynamic-form';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { AuthService } from 'src/app/core/services/auth.service';

import { CostFormAdminService } from 'src/app/core/services/cost-form-admin.service';
import {Subject} from 'rxjs';
import { TransactionInvoiceService } from '../../../pages/transaction/services/transaction-invoice.service';
import {  ControlValueAccessor, 
          NG_VALUE_ACCESSOR, 
          FormBuilder,
          FormGroup,          
          Validators,
          FormControl,
          NG_VALIDATORS
        } from '@angular/forms';

@Component({
  selector: 'prgov-cost-form-admin',
  templateUrl: './cost-form-admin.component.html',
  styleUrls: ['./cost-form-admin.component.scss'],
  
})
export class CostFormAdminComponent extends BaseDynamicForm implements OnInit {


    costs: any = [];
    invoice: any = [];
    cost: any = [];
    numberOfCostsRequired: any = 0;
    processId: any;
    constructor(    
        private route:ActivatedRoute,
        private router: Router,
        public translate: TranslateService,
        public dynamicFormService: DynamicFormService,
        public costFormService: CostFormAdminService,
        public authService: AuthService,
        public transactionInvoiceService: TransactionInvoiceService
    ) { 
        super();  
    
        translate.use(this.ls.get(this.langKey));

    
        this.costFormService.total = 0;
        this.costFormService.costs = [];
        this.costFormService.selectedCosts = [];
        this.costFormService.dynamicCosts = [];
        this.costFormService.subTotal = 0;  
        this.costFormService.total = 0;  
        this.costFormService.taxAmount = 0;  
        this.costFormService.discountAmount = 0;
        this.processId = this.route.snapshot.params['id'];
        
        
          this.costFormService
          .getCosts(this.processId, 2)
          .then((data: any)=>{
          
            if(this.transactionInvoiceService.invoice){
                this.costs = [];
                this.transactionInvoiceService.invoice.Costs.forEach((invoiceCost)=>{
                  this.cost = this.costFormService.costs.find(x => x.Id === invoiceCost.CostId);
                  this.cost.selected = true;
                  this.cost.Qty = invoiceCost.Qty;
                  //this.cost.Amount = invoiceCost.Amount;
                  this.costs.push(this.cost)
                })
            }else{

              this.costs = this.costFormService.costs
                .map(e => e['Id'])
                .map((e, i, final) => final.indexOf(e) === i && i)
                .filter(obj=> this.costFormService.costs[obj])
                .map(e => this.costFormService.costs[e]);
            }

            this.costFormService.costs = [];
            this.costFormService.costs = this.costs;
       
          });  
        

           
    }

    

    ngOnInit() {
    }
    
   
}

